<template>
  <div
    class="main-layout predicted-xlcs-page predicted-item-page"
  >
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="入学资料"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <ul class="s-study-wrapper">
            <li
              v-for="(item, index) in studyList"
              :key="index"
              @click="studyPreview(item)"
            >
              <i class="iconfont icon-xuexiziliao"></i>
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      studyList: [],
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {
    this.getStudyList();
  },
  methods: {
    // 获取学习资料列表
    getStudyList() {
      this.$http.get("/welcome-forecast/study/listAll").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.studyList = res.data;
        }
      });
    },
    studyPreview(data) {
      // this.download(data.url,data.name);
      window.open(data.url, "_blank");
    },
    // 下载图片
    download(url, fileName = "未知文件") {
      const el = document.createElement("a");
      el.style.display = "none";
      el.setAttribute("target", "_blank");
      /**
       * download的属性是HTML5新增的属性
       * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
       * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
       * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
       */
      fileName && el.setAttribute("download", fileName);
      el.href = url;
      console.log(el);
      document.body.appendChild(el);
      el.click();
    },
  },
};
</script>

<style lang="less" scoped>
.s-study-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
  padding-top: 20px;
  > li {
    width: 140px;
    padding: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    text-align: center;
    background-color: #f9f9f9;
    border: 1px solid #ddf0fc;
    border-radius: 4px;

    &:hover {
      box-shadow: 0 0 10px 0 #ddf0fc;
    }
    cursor: pointer;
    .icon-xuexiziliao {
      font-size: 40px;
      color: #489eff;
    }
    .title {
      line-height: 30px;
      text-align: center;
      color: #666;
    }
  }
}
</style>
